module.exports = "../study/imgs/maps/Tokyo/S8/Helth/Mosquito/Tokyo_Mosquito_MRI_RCP45_Mid.png";